export const CROSS_SELLING_MAX_VIEW_ITEMS = 10
export const FAVORITES_CROSS_SELLING_MAX_VIEW_ITEMS = 25
